export default function PartnersSection() {
  const partners = [
    'https://winka.io/wp-content/uploads/2024/01/asiagaming-logo-copy.png',
    'https://winka.io/wp-content/uploads/2024/01/betmgm-copy.png',
    'https://winka.io/wp-content/uploads/2024/01/BTI-Sports-2-copy.png',
    'https://winka.io/wp-content/uploads/2024/01/habanero_white-copy.png',
    'https://winka.io/wp-content/uploads/2024/01/Logo_Endorphina-copy.png',
    'https://winka.io/wp-content/uploads/2024/01/lucky_streak-copy.png',
    'https://winka.io/wp-content/uploads/2024/01/nolimit-city-copy.png',
    'https://winka.io/wp-content/uploads/2024/01/SBOBET_New_Logo-copy.png',
    'https://winka.io/wp-content/uploads/2024/01/betsoft-gray-2.png',
    'https://winka.io/wp-content/uploads/2024/01/BGaming_logo-gray-2.png',
    'https://winka.io/wp-content/uploads/2024/01/digitain-gray-2.png',
    'https://winka.io/wp-content/uploads/2024/01/evolution-gray-2.png',
    'https://winka.io/wp-content/uploads/2024/01/onlyplay-gray-2.png',
    'https://winka.io/wp-content/uploads/2024/01/pragmatic-gray-2.png',
    'https://winka.io/wp-content/uploads/2024/01/slogo_Betconstruct-gray-2.png',
    'https://winka.io/wp-content/uploads/2024/01/netent-logo-white-1.png'
  ];

  return (
    <section className="py-20 bg-[#0a1628]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <h3 className="text-3xl font-bold text-white mb-4">
            레알타드 솔루션은 글로벌 겜블링 기업의 공식 파트너입니다
          </h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-12">
          {partners.map((partner, index) => (
            <div 
              key={index}
              className="flex items-center justify-center p-4 bg-white/5 rounded-lg hover:bg-white/10 transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <img 
                src={partner} 
                alt={`Partner ${index + 1}`}
                className="w-full h-auto object-contain filter brightness-0 invert opacity-70 hover:opacity-100 transition-opacity"
              />
            </div>
          ))}
        </div>

        <div className="text-center animate-fade-in">
          <a 
            href="https://t.me/realtad_cs" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            텔레그램 문의
          </a>
        </div>
      </div>
    </section>
  );
}